module.exports = __webpack_public_path__ + "static/it_strategy-10847b77a677fb86d4ca348ee521c9e3.jpg";